var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLossArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow-up-02 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.4537 9.32144L10.3137 7.18144L9.00706 5.86812C8.45373 5.31479 7.55373 5.31479 7.00039 5.86812L3.54704 9.32144C3.09371 9.77477 3.42037 10.5481 4.05371 10.5481H7.79373H11.9471C12.5871 10.5481 12.9071 9.77477 12.4537 9.32144Z",
    fill: "#FF3366"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLossArrow);
export default __webpack_public_path__ + "static/media/loss-arrow.1b5f723ea8318163ce2f36c3b69a30bc.svg";
export { ForwardRef as ReactComponent };